// extracted by mini-css-extract-plugin
module.exports = {"input":"_DocumentInput_input__2bAAN","normal":"_DocumentInput_normal__3Ru0A","title":"_DocumentInput_title__RSsPI"};